import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* getBuyingMomentsDaysWatcherSaga() {
  yield takeLatest(types.GET_BUYING_MOMENT_DAYS_REQUEST, workerSaga);
}

export function fetchData() {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/buying-moment/days/`;

  return axios.get(url)
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga() {
  try {
    const response = yield call(fetchData);
    if (response && response.status === 200) {
      const { data } = response;

      yield put({ type: types.GET_BUYING_MOMENT_DAYS_SUCCESS, data });
    } else {
      yield put({ type: types.GET_BUYING_MOMENT_DAYS_FAILURE, error: response && response.data });
    }
  } catch (error) {
    yield put({ type: types.GET_BUYING_MOMENT_DAYS_FAILURE, 'error': error && error.data });
  }
}
